import { CaseForm, CaseRecordType } from '@avantstay/arriere-clients/dist/arriereBackoffice'

// Which form a classification renders is owned by the backoffice taxonomy
// (each nature carries a caseForm). This map only converts that enum to the
// legacy CaseRecordType the existing forms and payload builders are keyed by.
const CASE_FORM_TO_RECORD_TYPE: Record<string, string> = {
  [CaseForm.fieldOps]: CaseRecordType.fieldOps,
  [CaseForm.housekeeping]: CaseRecordType.housekeeping,
  [CaseForm.concierge]: CaseRecordType.concierge,
  [CaseForm.ownerRelations]: CaseRecordType.ownerRelations,
  [CaseForm.escalation]: CaseRecordType.escalation,
  [CaseForm.inspection]: CaseRecordType.inspection,
  [CaseForm.citation]: CaseRecordType.citation,
  [CaseForm.onboarding]: CaseRecordType.onboarding,
  [CaseForm.terminationRequest]: CaseRecordType.terminationRequest,
}

export const recordTypeFromCaseForm = (caseForm: CaseForm | null | undefined): CaseRecordType =>
  caseForm ? (CASE_FORM_TO_RECORD_TYPE[caseForm] as CaseRecordType) : CaseRecordType.fieldOps

// Record types the work-order edit forms (Fops/WorkOrder) can persist through
// updateCaseByInputs; other case forms have their own dedicated edit form.
export const WORK_ORDER_RECORD_TYPES = [
  CaseRecordType.fieldOps,
  CaseRecordType.housekeeping,
  CaseRecordType.inspection,
]
